import type { ImageProfile, ServerImage } from '../types/serverImages';

export function duoVersionAtLeast(version: string, minimum: string): boolean {
  if (!/^\d+(\.\d+){1,3}$/.test(version) || !/^\d+(\.\d+){1,3}$/.test(minimum)) return false;
  const actual = version.split('.').map(Number);
  const required = minimum.split('.').map(Number);
  for (let index = 0; index < Math.max(actual.length, required.length); index += 1) {
    const difference = (actual[index] || 0) - (required[index] || 0);
    if (difference !== 0) return difference > 0;
  }
  return true;
}

export function selectableServerImages(images: ServerImage[], profile: ImageProfile, minimumDuoVersion = '6.5.1'): ServerImage[] {
  return images.filter(image => image.profile === profile && image.status === 'READY' && image.jobStatus !== 'RUNNING'
    && (profile !== 'duo-proxy' || !image.installerEmbedded || duoVersionAtLeast(image.installerVersion || '', minimumDuoVersion)));
}
